/**
*  Copyright (c) 2022 Micro Focus Software Inc.  All Rights Reserved.
*
* THIS WORK IS AN UNPUBLISHED WORK AND CONTAINS CONFIDENTIAL PROPRIETARY
* AND TRADE SECRET INFORMATION OF MICRO FOCUS SOFTWARE INC. ACCESS  TO  THIS
* WORK IS RESTRICTED TO (I) MICRO FOCUS SOFTWARE INC. EMPLOYEES WHO HAVE A NEED
* TO  KNOW HOW TO  PERFORM  TASKS WITHIN  THE SCOPE  OF  THEIR   ASSIGNMENTS
* AND (II) ENTITIES OTHER  THAN  MICRO FOCUS SOFTWARE INC.  WHO  HAVE ENTERED
* INTO APPROPRIATE LICENSE   AGREEMENTS.  NO  PART  OF  THIS WORK MAY BE USED,
* PRACTICED, PERFORMED COPIED, DISTRIBUTED, REVISED, MODIFIED, TRANSLATED, ABRIDGED,
* CONDENSED, EXPANDED, COLLECTED, COMPILED, LINKED,  RECAST, TRANSFORMED
* OR ADAPTED  WITHOUT THE PRIOR WRITTEN CONSENT OF MICRO FOCUS SOFTWARE INC.
* ANY USE OR EXPLOITATION  OF  THIS WORK WITHOUT AUTHORIZATION COULD SUBJECT
* THE PERPETRATOR  TO CRIMINAL AND CIVIL LIABILITY.
*/

import { Component, Input, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ZSDTranslateService } from './../../../../../../common/zsd-translate.service';
import { KbacommentsService } from '../../../services/kbacomments.service';
import { KbaCommentCreateInfo, KbaCommentDetail, KbaComments } from './kbacomments';
declare var $:any;
@Component({
  selector: 'zsd-kbacomments',
  templateUrl: './kbacomments.component.html',
  styleUrls: ['./kbacomments.component.scss']
})
export class KbacommentsComponent implements OnInit {

  @Input() currentKbaId: number;
  kbaComments: KbaComments;
  kbaCommentsList: KbaCommentDetail[];
  parentId: number;
  parentIdFlag = false;
  parentCommentName: string;
  parentCommentText: string;
  replyToLabelFlag = false;
  kbaCommentMap: Map<number, KbaCommentDetail> = new Map<number, KbaCommentDetail>();
  kbaCommentText = '';

  constructor(private kbacommentservice: KbacommentsService,
    private toastr: ToastrService,
    public zsdTranslate: ZSDTranslateService) {
  }

  ngOnInit(): void {
    this.getAllComments();
  }

  dismisskbaCommentViewModal() {
    this.clearComment();
    this.replyToLabelFlag = false;
  }

  replyToComment(comment: KbaCommentDetail) {
    this.parentId = comment.id;
    this.parentCommentName = comment.owner.fullName;
    this.parentCommentText = comment.commentText;
    this.parentIdFlag = true;
    this.replyToLabelFlag = true;
  }

    // To Fetch all the Comments
    getAllComments() {
      this.kbacommentservice.getKbaComments(this.currentKbaId).subscribe(
        (kbaCommentList: KbaComments) => {
          this.kbaComments = kbaCommentList;
          this.kbaCommentsList = kbaCommentList.results;
          kbaCommentList.results.forEach(commentDetail => {
            this.kbaCommentMap.set(commentDetail.id, commentDetail);
          });
        });
    }

  addKbaComment() {
    let commentText = $('#newandreplycomment').val();
    let kbaCommentCreateInfo = new KbaCommentCreateInfo();
    kbaCommentCreateInfo.commentText = commentText.toString();
    if (this.replyToLabelFlag) {
    kbaCommentCreateInfo.parentId = this.parentId;
    }
    this.kbacommentservice.addComment(this.currentKbaId, kbaCommentCreateInfo).subscribe(
      (response) => {
        console.log(response);
        let message = this.zsdTranslate.getTranslatedString('KbaComments', 'successmessage');
        this.toastr.success(message);
        this.replyToLabelFlag = false;
        this.clearComment();
        this.getAllComments();
      },
      err => {
        this.toastr.error(err.localizedMessage);
      }
    );
  }

  clearComment() {
    $('#newandreplycomment').val('');
    this.kbaCommentText = '';
    this.replyToLabelFlag = false;
  }

  moveToParentComment(parentId: number) {
    let elmntToView = document.getElementById(parentId.toString());
    $('.note-box').css('border', '1px solid rgba(0, 0, 0, 0.2)');
    $('#' + parentId.toString()).parent().css('border', '1px solid #0078ef');
    elmntToView.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'start' });
  }
}
